export const deviceUtils = {
	isMobile() {
		return window.innerWidth < 480;
	},

	isTablet() {
		return window.innerWidth < 768;
	},

	isLaptop() {
		return window.innerWidth < 1024;
	},

	isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	},

	isIOS() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
	},

	isTouchMode() {
		return this.isTouchDevice() || this.isLaptop();
	},

	isLandscape() {
		return window.innerWidth > window.innerHeight;
	},

	isIpadLandscape() {
		return this.isIOS() && this.isLandscape();
	},

	isIpadPortrait() {
		return this.isIOS() && !this.isLandscape();
	},
};
